import {EnterprisePortalPropertiesContext} from "enterprise-components/src/context/EnterprisePortalPropertiesContextProvider";
import {useContext} from "react";

export function useEnterprisePortalPropertiesContext()
{
    const context = useContext(EnterprisePortalPropertiesContext);

    if (!context) {
        throw new Error(
            "useEnterprisePortalPropertiesContext must be used within the scope of EnterprisePortalPropertiesContextProvider"
        );
    }

    return context;
}
